import React, { useEffect, useRef } from 'react';
import {
  Manager,
  ManagerText,
  ManagerTitle,
  ManagerContact,
  FlashLink,
  InactiveLink,
  TooltipContent,
  TooltipWrap,
  TooltipCorner,
} from './styled';
import { LogClick } from 'features/shared/ClickStream';
import SideBarTemplate, { Link, Nav } from 'features/shared/layouts/shared/SideBarTemplate';
import Spacer from 'features/shared/Spacer';
import useUserData from 'hooks/useUserData';
import { useSurveysContext } from 'features/surveys/SurveysContext';
import useGratitudeCheck from 'hooks/useGratitudeCheck';
import { useGratitudesContext } from 'features/gratitudes/GratitudesContext';

const scrollToTop = () => window.scroll(0, 0);

const Sidebar = () => {
  const tooltipTimer = useRef<number | null>(null);
  const userData = useUserData();
  const isMunicipality = !!userData?.isMunicipality;
  const isRegion = !!userData?.isRegion;
  const isLargeCity = !!userData?.isLargeCity;
  const grInfo = userData?.grManager;
  const { enabledSendAnswers, showTooltip, setShowTooltip, avalibleSurvey } = useSurveysContext();
  const { years, lastAddedTimestamp } = useGratitudeCheck();
  const { lastVisitedPage } = useGratitudesContext();

  useEffect(() => {
    if (showTooltip && !tooltipTimer.current) {
      tooltipTimer.current = setTimeout(() => {
        setShowTooltip(false);
      }, 10000);
    }
  }, [showTooltip]);
  return (
    <SideBarTemplate>
      <Nav data-qa-id="sidebar_block">
        <LogClick eventType="open_main_page" eventInfo="Переход на главную страницу">
          <Link to="/main" onClick={scrollToTop} data-qa-id="main_page">
            Главная
          </Link>
        </LogClick>
        <LogClick eventType="open_schools_page" eventInfo="Переход на страницу школ">
          <Link to="/schools" onClick={scrollToTop}>
            Школы
          </Link>
        </LogClick>
        <LogClick eventType="open_olympiads_page" eventInfo="Переход на страницу олимпиад">
          <Link to="/olympiads" onClick={scrollToTop}>
            Олимпиады
          </Link>
        </LogClick>
        {/*<LogClick eventType="open_knowledge_slices_page" eventInfo="Переход на страницу срезов знаний">*/}
        {/*  <Link to="/knowledge_slices" onClick={scrollToTop}>*/}
        {/*    Срезы знаний*/}
        {/*  </Link>*/}
        {/*</LogClick>*/}
        {/* <LogClick eventType="open_courses_page" eventInfo="Переход на страницу КПК">
          <Link to="/courses" onClick={scrollToTop}>
            КПК
          </Link>
        </LogClick> */}
        {/*<LogClick eventType="open_webinars_page" eventInfo="Переход на страницу обучения учителей">*/}
        {/*  <Link to="/webinars" onClick={scrollToTop}>*/}
        {/*    Обучение учителей*/}
        {/*  </Link>*/}
        {/*</LogClick>*/}
        {/* {isRegion ? (
          <LogClick eventType="open_teacher_review_page" eventInfo="Переход на страницу Отзывы учителей">
            <Link to="/reviews" onClick={scrollToTop}>
              Отзывы учителей
            </Link>
          </LogClick>
        ) : null} */}
        {years.length > 0 && !!years.length && (userData?.userType != 'region' || userData.largeCity) && (
          <LogClick eventType="open_gratitude_page" eventInfo="Переход на страницу БЛАГОДАРНОСТИ">
            <Link
              to="/gratitude"
              onClick={scrollToTop}
              style={{ color: (lastAddedTimestamp || 0) > (lastVisitedPage || 0) ? '#1CC67F' : '' }}
            >
              Портфолио
            </Link>
          </LogClick>
        )}
        <LogClick eventType="open_faq_page" eventInfo="Переход на страницу FAQ">
          <Link to="/faq" onClick={scrollToTop}>
            Частые вопросы
          </Link>
        </LogClick>
      </Nav>
      <Spacer />
      <Nav>
        {!!avalibleSurvey && (
          <LogClick eventType="open_surveys" eventInfo="Переход на страницу Пройти опрос">
            <div style={{ position: 'relative' }}>
              <Link
                as={enabledSendAnswers ? FlashLink : InactiveLink}
                to="/surveys"
                onClick={scrollToTop}
                style={{ textTransform: 'none' }}
              >
                Пройти опрос
              </Link>
              {showTooltip && (
                <TooltipWrap>
                  <TooltipContent>Пройти опрос можно здесь</TooltipContent>
                  <TooltipCorner />
                </TooltipWrap>
              )}
            </div>
          </LogClick>
        )}
        {/* <LogClick eventType="open_expert_opinion_page" eventInfo="Переход на страницу Заключения экспертов">
          <Link to="/expert_opinion" onClick={scrollToTop} style={{ textTransform: 'none' }}>
            Заключения экспертов
          </Link>
        </LogClick> */}
      </Nav>
      {grInfo ? (
        <Manager>
          <ManagerTitle>Ваш менеджер:</ManagerTitle>
          <ManagerText>{grInfo.full_name}</ManagerText>
          <ManagerContact href={`mailto:${grInfo.email}`}>{grInfo.email}</ManagerContact>
          {(grInfo as any).phone && (
            <ManagerContact href={`tel:${(grInfo as any).phone.replace(/[^0-9\+]/g, '')}`}>
              {(grInfo as any).phone}
            </ManagerContact>
          )}
        </Manager>
      ) : null}
    </SideBarTemplate>
  );
};

export default Sidebar;
